import MyMapsPopup from "~/es6/mymaps.popup";
import { node } from "~/util/dom";
import { _ } from "~/i18n";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

export default class ActivitiesEditPopup extends MyMapsPopup {
	_data: any;

	set data(data) {
		this._data = data;
		this._dom.deleteTitle.innerHTML = _("mymap.activity.edit.deleteTitle", { trackTitle: Mapy.Util.escapeHTML(this._data.title) });
		this._dom.deleteText.innerHTML = _("mymap.activity.edit.deleteText");
	}

	open() {
		super.open();
		this._dom.container.addEventListener("click", this);
	}

	close() {
		super.close();
		this._dom.container.removeEventListener("click", this);
	}

	handleEvent(event) {
		super.handleEvent(event);

		if (event.type === "click") {
			const logger = Mapy.getComponent("logger");

			switch (event.target) {
				case this._dom.cancelBtn:
				case this._dom.cancelDeleteBtn:
					this.close();
					break;

				case this._dom.deleteBtn:
					Mapy.ProviderMapyBox.trackDelete([this._data.id]).then(() => {
						this.close();
						Notifications.notify({
							content: _("mymap.activity.notify.delete"),
							type: NOTIFICATIONS_TYPE.SUCCESS,
						});
						logger.log("my_maps_item_delete", { type: "activity" });
						this._sendSignal("deleted", this._data.id);
					}, () => {
						Notifications.notify({
							content: _("mymap.activity.notify.deleteError"),
							type: NOTIFICATIONS_TYPE.ERROR,
						});
						this.close();
					});
					break;

				default:
					//
			}
		}
	}

	_create() {
		super._create();
		this._dom.container.classList.add("activities-edit");
		this._createDelete();
	}

	_createDelete() {
		const deleteContainer = node("div", { className: "delete" });
		const title = node("h3", {}, "");
		const text = node("p", {});
		const buttons = node("div", { className: "buttons" });
		const cancelBtn = node("button", { className: "cancel", textContent: _("cancel") });
		const deleteBtn = node("button", { className: "delete", textContent: _("delete") });

		this._dom.deleteTitle = title;
		this._dom.deleteText = text;
		cancelBtn.setAttribute("type", "button");
		deleteBtn.setAttribute("type", "button");
		buttons.appendChild(deleteBtn);
		buttons.appendChild(cancelBtn);
		this._dom.deleteButtons = buttons;
		this._dom.deleteBtn = deleteBtn;
		this._dom.cancelDeleteBtn = cancelBtn;
		deleteContainer.appendChild(title);
		deleteContainer.appendChild(text);
		deleteContainer.appendChild(buttons);

		this._dom.deleteContainer = deleteContainer;
		this._dom.container.appendChild(this._dom.deleteContainer);
	}
}
